jQuery(document).ready(function ($) {
	const loadMore = $('#load-more-suggestions');
	let paged = loadMore.data('paged');
	const maxPages = loadMore.data('max-pages');
	const container = $('.archive-suggestions');

	loadMore.click(function (event) {
		event.preventDefault();

		$.ajax({
			method: 'POST',
			url: suggestions.url,
			data: {
				nonce: suggestions.nonce,
				locale: suggestions.locale,
				paged: paged,
				action: 'more_suggestions'
			},
			beforeSend: function () {
				loadMore.prop('disabled', true);
			},
			success: function (responce) {
				paged++;
				container.append(responce);
				if (paged == maxPages) {
					loadMore.remove();
				}
				loadMore.prop('disabled', false);
			}
		});
	});
}(jQuery));